module.exports = __webpack_public_path__ + "img/nieve.57750e9d.png";